import sizes from "../../design-tokens/sizes";
import { chevronRight } from "../../js/helpers/built-in-icons";
import { dispatchEvent, renderState } from "../../js/state-machine";
import { isHTMLElement, isObject, prefix } from "../../js/utilities";

export const componentName = "TabItem";

export const tabItemClasses = {
    mobileStackedChevron: `${prefix}tabs__tab__chevron`,
};

export const views = {
    active: { attrs: { "aria-selected": "true", tabindex: "" } },
    inactive: { attrs: { "aria-selected": "false", tabindex: "-1" } },
    stacked: { attrs: { "aria-selected": "false", tabindex: "" } },
};

export default function TabItem(element, props) {
    if (!isHTMLElement(element)) return console.error(`${componentName} missing element`);
    if (element[componentName]) return console.warn(`${componentName} already initialized`);
    if (!isObject(props)) props = {};

    const { index, handleTabKeydown, tabsStore, setActiveTab, isMobileStacked, wrapper, eventMap } =
        props;
    const mediumBreakpoint = parseInt(sizes.breakpoints["breakpoints-md"]()) - 1;

    const rightChevronIconSvg = new DOMParser().parseFromString(chevronRight(), "text/html").body
        .firstChild;
    rightChevronIconSvg.classList.add(tabItemClasses.mobileStackedChevron);

    const handleClick = () => {
        setActiveTab(index);
    };

    const handleKeydown = (e) => {
        handleTabKeydown(e, index);
    };

    const handleStateChange = (newStateList) => {
        const isActive = newStateList[index];

        const isScreenBiggerThanMedium = window.innerWidth >= mediumBreakpoint;

        if (isScreenBiggerThanMedium) {
            renderState(isActive ? views.active : views.inactive, element);
        } else if (isMobileStacked) {
            renderState(views.stacked, element);
        } else {
            renderState(isActive ? views.active : views.inactive, element);
        }

        if (!currentState && newStateList[index]) {
            dispatchEvent(eventMap.opened, wrapper, { index });
        } else if (currentState && !newStateList[index]) {
            dispatchEvent(eventMap.closed, wrapper, { index });
        }

        currentState = newStateList[index];
    };

    const handleStackedIcon = () => {
        const isScreenBiggerThanMedium = window.innerWidth >= mediumBreakpoint;

        if (
            !isScreenBiggerThanMedium &&
            isMobileStacked &&
            !element.contains(rightChevronIconSvg)
        ) {
            element.appendChild(rightChevronIconSvg);
        } else if (isScreenBiggerThanMedium && element.contains(rightChevronIconSvg)) {
            rightChevronIconSvg.remove();
        }
    };

    const dispose = () => {
        element.removeEventListener("click", handleClick);
        element.removeEventListener("keydown", handleKeydown);

        element[componentName] = null;
        element = null;

        tabsStore.unsubscribe(handleStateChange);

        if (rightChevronIconSvg) rightChevronIconSvg.remove();

        window.removeEventListener("resize", handleStackedIcon);
    };

    element.addEventListener("click", handleClick);
    element.addEventListener("keydown", handleKeydown);
    window.addEventListener("resize", handleStackedIcon);

    let currentState = element.getAttribute("aria-selected") === "true";
    handleStackedIcon();

    // Subscribe to main store
    tabsStore.subscribe(handleStateChange);

    const api = { dispose };

    element[componentName] = api;

    return api;
}
